import AppEvents from 'Shared/app-events';
import CartApi from 'Api/cart-api';

import AsideTab from './asideTab';


export default class AsideRight extends AsideTab
{
    constructor(view, options = {
        id: "aside-right",
        tabId: "aside-right__tab",
        cartTabId: "__cart",
        bookmarkTabId: "__bookmark",
        compareTabId: "__compare",
    }) {
        super(options);

        this.view = view;
        this.contextLoaded = ko.pureComputed(view.contextLoaded);

        this.#bindEvents();
    }

    showCart = () => this.showTab(this.options.cartTabId);
    showBookmark = () => this.showTab(this.options.bookmarkTabId);
    showCompare = () => this.showTab(this.options.compareTabId);

    #bindEvents = () => {
        AppEvents.on("aside.cart.show", this.showCart);
        AppEvents.on("aside.bookmark.show", this.showBookmark);
        AppEvents.on("aside.compare.show", this.showCompare);


        AppEvents.on(CartApi.Events.EXTENDED_UNI_MEASURESUNIT, async args => {
            var model = await import('Common/measuresPanel');;

            const data = {
                ProductId: args.OrderUnit.ProductId(),
                ProductUnitId: args.OrderUnit.ProductUnitId(),
                NVProjectId: args.NVProjectId(),
                NVContractId: args.NVContractId(),
                NVOrderId: args.NVOrderId(),
                //NVOrderType: args.NVOrderType()
            };

            const panel = new model.default(this, args.OrderUnit.ExtendedUnitConfigUrl(), data);
            await panel.init();

            this.showCart();
            panel.show();
        });
    }
}